import { GroupGoal, GroupGoalModel } from "./group-goal.model";

export class GroupGoalsData {
    goalPeriodId: number;

    isSelf: boolean;
    loading: boolean;
    groupGoals: GroupGoal[] = [];        // group goals of the employee's leader
    
    isAddGroupGoal = false;
    newGroupGoal = new GroupGoalModel();
}